import { memo } from "react";
import { IonLabel } from "@ionic/react";
import cx from "classnames";
import s from "./PastWinners.module.scss";
import pastWinner1 from "../Images/pastWinner_1.png";
import pastWinner2 from "../Images/pastWinner_2.png";
import pastWinner3 from "../Images/pastWinner_3.png";
import pastWinner4 from "../Images/pastWinner_4.png";
import pastWinner5 from "../Images/pastWinner_5.png";
import pastWinner6 from "../Images/pastWinner_6.png";
import pastWinner7 from "../Images/pastWinner_7.png";
import { useBreakpoint } from "../../../../../Common/utils/common";
import { useWebUserStore } from "../../../../CommonStores";
import { shallow } from "zustand/shallow";
import Stripe from "stripe";

const PastWinners = () => {
  const [user, latestFailedStripePaymentAttempt] = useWebUserStore(
    (store) => [store.user, store.latestFailedStripePaymentAttempt],
    shallow
  );
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "mobile";

  const paymentAttempts = latestFailedStripePaymentAttempt
    ? (latestFailedStripePaymentAttempt?.data.object as Stripe.Invoice)
        .attempt_count || 0
    : 0;

  const getImg = () => {
    switch (paymentAttempts) {
      case 1:
        return pastWinner1;
      case 2:
        return pastWinner2;
      case 3:
        return pastWinner3;
      case 4:
        return pastWinner4;
      case 5:
        return pastWinner5;
      case 6:
        return pastWinner6;
      case 7:
        return pastWinner7;
      default:
        return pastWinner1;
    }
  };

  return (
    <div className={cx(s.pastWinners, { [s.mobile]: isMobile })}>
      <IonLabel className={cx(s.title)}>
        MEMBERS <span>WIN $300,000</span> EVERY MONTH!
      </IonLabel>
      <div className={s.photoContainer}>
        <img src={getImg()} alt="" loading="lazy" decoding="async" />
      </div>
    </div>
  );
};

export default memo(PastWinners);
